module.exports = __webpack_public_path__ + "img/icon4.19707c5e.png";